import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';

function ShortTagTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);

  useEffect(() => {}, [value]);
  return (
    <TextNumberEntryView
      chars={specialCharTextNumbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={54}
      defaultKey4={50}
      defaultKey5={55}
      defaultKey6={63}
      defaultKey7={65}
      defaultKey8={0}
      defaultKey9={54}
      defaultKey10={50}
      defaultKey11={58}
      defaultKey12={2}
      onSave={onExit}
      onLeftHold={onExit}
      title="Set Short Tag"
      caption="0x19, 0x4B, 0x70, 0xC3, 0x0C, 0x20"
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default ShortTagTN;
